import React, { useState, useEffect } from "react";
import Checkbox from "./Checkbox";
import Input from "./CurrencyInput";

export interface ICheckboxGroupProps {
    required: boolean,
    inputName: string,
    name: string,
    value: number,
    label: string,
    onChange: (string, number, boolean) => void
}
export default (props: ICheckboxGroupProps) => {
    const { required, inputName, label, value, onChange } = props;
    const [checked, setChecked] = useState(false);
    const [inputValue, setInputValue] = useState(value);

    function handleChange(e) {
        const isChecked = e.target.checked;
        setChecked(isChecked);
        if (!isChecked) {
            setInputValue(0);
        }
    }

    useEffect(() => {
        onChange(inputName, inputValue, required);
    }, [inputValue, checked]);

    function handleInputChange(unusedVar, value) {
        setInputValue(value);
    }

    const inputProps = {
        showLabel: false,
        onChange: handleInputChange,
        containerClassName: "",
        inputClassName: "px-3",
        showCurrencyIcon: true,
        inputType: "number",
        value: inputValue,
        disabled: !checked,
        name: inputName,
        id: inputName,
        required
    };

    const checkboxProps = {
        name: inputName,
        checked,
        onChange: handleChange,
        label
    };

    return (
        <div className="form-group checkbox-group">
            <Checkbox {...checkboxProps} />
            <Input {...inputProps} />
        </div>
    );
};